



































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import DeliveryRule from '@/api/models/DeliveryRule'
import AccountOption from '@/api/models/AccountOption'
import { ExtraFields } from '@/models/ExtraFields'
import {
    getDefaultAccountOptions,
    getDefaultSystemSettings,
    getEmptyExtraFields,
    isEmptyString
} from '@/components/helper'
import { Dictionary } from '@/dictionary/Dictionary'
import { deliveryAddCostTypeDict, deliveryAddCostTypes } from '@/dictionary/DeliveryAddCostTypeDict'
import { ExtraFieldCodeEnum } from '@/enum/ExtraFieldsCodeEnum'
import SystemSettings from '@/models/SystemSettings'
import { deliveryCostDict } from '@/dictionary/DeliveryCostDict'
import AccountOptions from '@/models/AccountOptions'
import { deliveryPriceRoundingModes } from '@/dictionary/DeliveryPriceRoundingModeDict'
import { tariffTypesDict } from '@/dictionary/TariffTypesDict'
import { paymentSumDistributionDict } from '@/dictionary/PaymentSumDistributionDict'

@Component
export default class AccountDeliveryCostView extends Vue {
    @Prop({ type: Array, default: () => [] })
    private deliveryRules: Array<DeliveryRule>

    @Prop({ type: Object, default: () => ({}) })
    private deliveryRecipientCostFree: AccountOption

    @Prop({ type: Object, default: () => ({}) })
    private currentExtraFields!: ExtraFields

    @Prop({ type: Object, default: () => ({}) })
    private currentSettingsModule: SystemSettings

    @Prop({ type: Object, default: () => ({}) })
    private currentAccountOptions: AccountOptions

    @Prop({ type: Boolean, default: true })
    private showDynamicRules: boolean

    private selectedAccountOptions: AccountOptions = getDefaultAccountOptions()
    private selectedSettingsModule: SystemSettings = getDefaultSystemSettings()
    private selectedExtraField: ExtraFields = getEmptyExtraFields()
    protected localRules: Array<DeliveryRule> = []

    private readonly eventUpdateDeliveryRules = 'updateDeliveryRules';
    private readonly eventDeleteDeliveryRules = 'deleteDeliveryRule';
    private error = ''

    @Watch('currentAccountOptions')
    selectedOptions(): void {
        this.selectedAccountOptions = Object.assign({}, this.currentAccountOptions)
    }

    @Watch('currentSettingsModule')
    selectedSettings(): void {
        this.selectedSettingsModule = Object.assign({}, this.currentSettingsModule)
    }

    @Watch('currentExtraFields')
    currentExtraFieldsUpdate() {
        this.selectedExtraField = Object.assign({}, this.currentExtraFields)
    }

    @Watch('deliveryRules')
    changeDeliveryRules(): void {
        this.localRules = Object.assign([], this.deliveryRules)
    }

    created() {
        this.localRules = Object.assign([], this.deliveryRules)
    }

    get showDeliveryAsProductWarning(): boolean {
        const hasDeliveryAsProduct = this.currentAccountOptions.deliveryAsProduct?.value === true
        const hasRules = this.localRules.length > 0

        return hasDeliveryAsProduct && hasRules
    }

    get deliveryPriceRoundingModes(): Array<Dictionary> {
        return deliveryPriceRoundingModes
    }

    get deliveryCost(): Array<Dictionary> {
        return deliveryCostDict
    }

    get tariffTypes(): Array<Dictionary> {
        return tariffTypesDict
    }

    get paymentSumDistributionDict(): Array<Dictionary> {
        return paymentSumDistributionDict
    }

    updateOption(code: string): void {
        if (this.selectedAccountOptions[code]) {
            this.$emit('updateAccountOptionEvent', this.selectedAccountOptions[code])
        }
    }

    updateRules(): void {
        if (this.deliveryRecipientCostFree) {
            this.$emit('updateAccountOptionEvent', this.deliveryRecipientCostFree)
        }
    }

    updateSetting(codeSetting: string): void {
        if (this.selectedSettingsModule[codeSetting]) {
            this.$emit('updateSettingModule', this.selectedSettingsModule[codeSetting])
        }
    }

    removeFieldFromChecked(optionName: string, field: string): void {
        const values = this.selectedAccountOptions[optionName].value as Array<string>
        const nonExistValue = !values.find(value => value === field)

        if (nonExistValue) {
            values.push(field)
        } else {
            const index = values.findIndex(value => value === field)
            values.splice(index, 1)
        }

        this.updateOption(optionName)
    }

    get addCostTypes(): Array<Dictionary> {
        return deliveryAddCostTypeDict;
    }

    protected createRule() {
        const newRule: DeliveryRule = {
            threshold: 0,
            value: '*'
        };
        this.localRules.push(newRule)
    }

    protected removeRule(idx: number) {
        const removed = this.localRules.splice(idx, 1)
        if (undefined !== removed[0].id) {
            this.$emit(this.eventDeleteDeliveryRules, removed[0])
        }
    }

    protected getErrorThreshold(threshold) {
        if (threshold.length < 1) {
            return this.$t('settings.deliveryRules.errors.emptyError')
        }

        return false
    }

    protected getErrorValue(value) {
        if (value.length < 1) {
            return this.$t('settings.deliveryRules.errors.emptyError')
        }

        if (!value.match(/^(\*|[\d,.]+)$/)) {
            return this.$t('settings.deliveryRules.errors.invalidError')
        }

        return false
    }

    protected validateRule(rule: DeliveryRule) {
        const errors: Array<string> = []
        if (String(rule.threshold).length < 1) {
            errors.push(String(rule.threshold))
        }

        if (rule.value.length < 1) {
            errors.push(rule.value)
        }

        if (!rule.value.match(/^(\*|[\d,.]+)$/)) {
            errors.push(rule.value)
        }

        if (errors.length < 1) {
            this.saveRule(rule)
        }
    }

    protected saveRule(rule: DeliveryRule): void {
        const converted = {
            id: rule.id,
            threshold: Math.min(1000000000, Math.round(Number(rule.threshold))),
            value: this.convertValue(rule.value)
        }

        this.$emit(this.eventUpdateDeliveryRules, converted)
    }

    changeAddCostData(): void {
        this.clearError()
        const addCost = this.selectedExtraField.deliveryExtraDataAddCost.value as number
        this.selectedExtraField.deliveryExtraDataAddCost.value = addCost

        const error = this.validateAddCost()
        if (!isEmptyString(error)) {
            this.error = error
            return;
        }

        this.updateExtraFields(ExtraFieldCodeEnum.deliveryExtraDataAddCost)
        this.updateExtraFields(ExtraFieldCodeEnum.deliveryExtraDataAddCostType)
    }

    validateAddCost(): string {
        const type = this.selectedExtraField.deliveryExtraDataAddCostType.value as string
        const cost = Math.round(this.selectedExtraField.deliveryExtraDataAddCost.value as number)
        if (
            type === deliveryAddCostTypes.PERCENT &&
            (cost > 100 || cost < 0)
        ) {
            return this.$t('settings.extraFields.deliveryAddCostType.errorUpdateCost').toString()
        }

        return '';
    }

    updateExtraFields(fieldCode: string): void {
        this.$emit('updateExtraFields', this.selectedExtraField[fieldCode])
    }

    clearError(): void {
        this.error = ''
    }

    private convertValue(value) {
        return (value === '*') ? value : Number.parseFloat(value.replace(',', '.')).toFixed(2)
    }
}
